import React, {useEffect} from 'react';
import {STRIPE_PUBLISHABLE_KEY} from "../libs/keys";
import {addStripeToHead} from "../utils/stripe";
import ManualPricingTable from "./billing/ManualPricingTable";
import {AccountType, StripePriceObject, UNIT_AMOUNT} from "./billing/stripePriceObject";


export default function StripePricingTable({
    tableId,
    groupId,
    prePrices,
    postPrices,
    filterScope,
    center,
    redirectTo = '',
    customerEmail = '',
    clientReferenceId = undefined,
}: {
    groupId?: number;
    prePrices?: StripePriceObject[];
    postPrices?: StripePriceObject[];
    center?: boolean;
    tableId: string;
    redirectTo?: string,
    customerEmail?: string,
    clientReferenceId?: string,
    filterScope?: boolean;
}) {
    const isStripe = tableId?.indexOf('prctbl_') === 0;

    useEffect(() => {
        if (isStripe) addStripeToHead();
    }, [isStripe]);


    return (
        <div className="position-relative">
            {tableId && typeof tableId === 'string' && (
                isStripe ? (
                    <>
                        {redirectTo && (
                            <a href={redirectTo} className="position-absolute h-100 w-100">
                                &nbsp;
                            </a>
                        )}
                        {/* @ts-ignore */}
                        <stripe-pricing-table key={tableId} pricing-table-id={tableId} publishable-key={STRIPE_PUBLISHABLE_KEY} customer-email={customerEmail} client-reference-id={clientReferenceId}>{tableId}</stripe-pricing-table>
                    </>
                ) : (
                    <ManualPricingTable
                        endpoint={tableId}
                        groupId={groupId}
                        prePrices={prePrices}
                        postPrices={postPrices}
                        filterScope={filterScope}
                        center={center}
                    />
                )
            )}
        </div>
    );
}


export const PRICING_TABLE_PRODUCT: Record<string, StripePriceObject> = {
    INSTITUTE: {
        id: 'custom_fearless_price',
        product: {
            name: 'Institute',
            metadata: {
                accountType: AccountType.Group,
            },
            description: 'Contact us for custom, on-site solutions tailored to your institute\'s specific needs. Photo51 Institute plans offer scalability, advanced security features, and dedicated support to empower your large-scale research initiatives.\n',
        },
        unit_amount: UNIT_AMOUNT.CUSTOM,
        currency: 'eur',
    },
}
